import { useState } from "react";
import { LuX, LuPlus, LuCheck } from "react-icons/lu";
import axios from "../../axios";
import * as styled from "./WordPopover.styled";

const STUDENT_KEY = "presentStudentId";

const readStudent = () => {
  try {
    return window.localStorage.getItem(STUDENT_KEY) || "";
  } catch (error) {
    return "";
  }
};

// Виділене слово → «Додати в словник учня». Переклад вписує вчитель (автопереклад прибрано — якість була погана).
// Показується лише вчителю.
function WordPopover({ selection, teacher, students, onClose }) {
  const [translation, setTranslation] = useState("");
  const [studentId, setStudentId] = useState(readStudent);
  const [status, setStatus] = useState(null);

  const chooseStudent = (id) => {
    setStudentId(id);
    try {
      window.localStorage.setItem(STUDENT_KEY, id);
    } catch (error) {}
  };

  const add = async () => {
    if (!studentId || !translation.trim()) return;
    setStatus("saving");
    try {
      await axios.post(`${studentId}/vocabulary`, {
        word: selection.text,
        translation: translation.trim(),
        addedBy: "teacher",
        teacherName: teacher.name,
        teacherId: teacher._id,
      });
      setStatus("saved");
    } catch (error) {
      setStatus("error");
    }
  };

  // Не виходимо за край екрана
  const left = Math.min(Math.max(selection.x, 170), window.innerWidth - 170);
  const top = selection.y + 12;

  return (
    <styled.Popover style={{ left, top }} onMouseDown={(event) => event.stopPropagation()}>
      <styled.Close onClick={onClose} aria-label="Close">
        <LuX size={16} />
      </styled.Close>
      <styled.Word>{selection.text}</styled.Word>
      <styled.Translation
        value={translation}
        onChange={(event) => setTranslation(event.target.value)}
        placeholder="Впишіть переклад"
        autoFocus
      />
      {students.length > 0 && (
        <>
          <styled.Select value={studentId} onChange={(event) => chooseStudent(event.target.value)}>
            <option value="">Оберіть учня…</option>
            {students.map((student) => (
              <option key={student._id} value={student._id}>
                {student.name}
              </option>
            ))}
          </styled.Select>
          <styled.Add onClick={add} disabled={!studentId || !translation.trim() || status === "saving" || status === "saved"} $saved={status === "saved"}>
            {status === "saved" ? (
              <>
                <LuCheck size={16} /> Додано в словник
              </>
            ) : (
              <>
                <LuPlus size={16} /> Додати в словник учня
              </>
            )}
          </styled.Add>
          {status === "error" && <styled.Error>Не вдалося додати слово</styled.Error>}
        </>
      )}
    </styled.Popover>
  );
}

export default WordPopover;
